/* BOLTRON — Feel-First editorial landing.
   1. Scroll reveal for [data-edb-reveal].
   2. Section 07 colour carousel: a view of the purchase controller's state
      (assets/kt-boltron-purchase.js). The centred slide asks for its variant
      with ktb:request-variant; the carousel follows ktb:variant-change.
   3. Section 08 card deck + gift dialog, adapted from the Roulette Feel-First
      sales section (assets/roulette-feel-first-purchase.js). Below 990px the
      cards stack and swipe; from 990px they sit side by side. Same rule as 07:
      the deck asks the controller and follows ktb:variant-change. */
(function () {
  var root = document.getElementById('ed-boltron-page');
  if (!root) return;

  var toArray = function (list) {
    return Array.prototype.slice.call(list || []);
  };
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── 3. Purchase deck (08) ────────────────────────────────────────── */
  /* Own function scopes: the 07 carousel below declares names of its own. */
  var buy = root.querySelector('[data-edb-deck-root]');
  if (buy) {
    initDeck(buy);
    initGifts(buy);
  }

  function initDeck(buy) {
    var deck = buy.querySelector('[data-edb-deck]');
    var track = deck && deck.querySelector('[data-edb-deck-track]');
    var cards = track ? toArray(track.querySelectorAll('[data-edb-card]')) : [];
    if (!cards.length) return;
    var dots = toArray(buy.querySelectorAll('[data-edb-deck-dot]'));
    /* From 990px the cards sit side by side (CSS): no stacking, swipe or inert cards. */
    var wide = window.matchMedia('(min-width: 990px)');
    /* Resting tilt of each card shell when it is not the active card. */
    var TILT = [-4, -2, 1, 3];
    /* Per |offset| from the active card: x as a fraction of card width, scale. */
    var GEOMETRY = { x: [0, 0.075, 0.095, 0.11], scale: [1, 0.965, 0.925, 0.9] };
    var current = 0;
    cards.forEach(function (card, index) {
      if (card.classList.contains('is-active')) current = index;
    });

    var lookup = function (list, value) {
      var a = Math.min(value, list.length - 1);
      var low = Math.floor(a);
      var high = Math.min(low + 1, list.length - 1);
      return list[low] + (list[high] - list[low]) * (a - low);
    };

    var layout = function (dragX) {
      if (wide.matches) {
        cards.forEach(function (card, index) {
          card.style.transform = card.style.zIndex = card.style.opacity = '';
          card.style.removeProperty('--edb-counter');
          card.classList.toggle('is-active', index === current);
        });
        return;
      }
      dragX = dragX || 0;
      var width = cards[current].offsetWidth || 1;
      var progress = dragX / width;
      cards.forEach(function (card, index) {
        var isCurrent = index === current;
        var offset = isCurrent ? 0 : index - current + progress;
        var distance = Math.abs(offset);
        var x = isCurrent ? dragX : Math.sign(offset) * lookup(GEOMETRY.x, distance) * width;
        var rotation = isCurrent ? Math.max(-5, Math.min(5, progress * 5)) : TILT[index % TILT.length] * Math.min(distance, 1);
        var scale = isCurrent ? 1 : lookup(GEOMETRY.scale, distance);
        card.style.transform = 'translate3d(' + x.toFixed(2) + 'px, 0, 0) rotate(' + rotation.toFixed(3) + 'deg) scale(' + scale.toFixed(4) + ')';
        card.style.setProperty('--edb-counter', (-rotation).toFixed(3) + 'deg');
        card.style.zIndex = String(isCurrent ? 50 : 40 - Math.round(distance * 10));
        card.style.opacity = distance > 2 ? String(Math.max(0, 3 - distance)) : '1';
        card.classList.toggle('is-active', isCurrent);
      });
    };

    var sync = function (index) {
      current = index;
      cards.forEach(function (card, i) {
        var hidden = !wide.matches && i !== current;
        card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        var content = card.querySelector('.edb-card__content');
        if (content) content.inert = hidden;
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
      layout();
    };

    var indexOf = function (variantId) {
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getAttribute('data-variant-id') === String(variantId)) return i;
      }
      return -1;
    };

    /* Refused while the cart is busy: the controller re-emits its state. */
    var request = function (index) {
      index = Math.max(0, Math.min(index, cards.length - 1));
      if (index === current) {
        layout();
        return;
      }
      if (window.KTBoltronPurchase) {
        var id = Number(cards[index].getAttribute('data-variant-id'));
        document.dispatchEvent(new CustomEvent('ktb:request-variant', { detail: { variantId: id, source: 'deck' } }));
      } else {
        sync(index);
      }
    };

    document.addEventListener('ktb:variant-change', function (event) {
      var index = event.detail ? indexOf(event.detail.variantId) : -1;
      if (index > -1) sync(index);
      else layout();
    });

    /* Swipe: horizontal drags move the top card; vertical scrolling stays native (touch-action: pan-y). */
    var drag = null;
    var suppressClick = false;
    track.addEventListener('pointerdown', function (event) {
      if (wide.matches || (event.pointerType === 'mouse' && event.button !== 0)) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, t: event.timeStamp, dx: 0, active: false };
    });
    track.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x;
      var dy = event.clientY - drag.y;
      if (!drag.active) {
        if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) {
          drag = null;
          return;
        }
        if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        drag.active = true;
        if (track.setPointerCapture) track.setPointerCapture(event.pointerId);
        deck.classList.add('is-dragging');
      }
      var atEdge = (dx > 0 && current === 0) || (dx < 0 && current === cards.length - 1);
      drag.dx = atEdge ? dx * 0.3 : dx;
      layout(drag.dx);
    });
    var endDrag = function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var finished = drag;
      drag = null;
      if (!finished.active) return;
      deck.classList.remove('is-dragging');
      suppressClick = true;
      window.setTimeout(function () {
        suppressClick = false;
      }, 0);
      var width = cards[current].offsetWidth || 1;
      var velocity = finished.dx / Math.max(1, event.timeStamp - finished.t);
      /* Far enough, or a real flick (fast and more than a nudge). */
      var passed = Math.abs(finished.dx) > width * 0.18 || (Math.abs(finished.dx) > 40 && Math.abs(velocity) > 0.45);
      if (passed && finished.dx < 0) request(current + 1);
      else if (passed && finished.dx > 0) request(current - 1);
      else layout();
    };
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    /* A peeking card is picked by tapping it (its content is inert until it is active). */
    track.addEventListener('click', function (event) {
      if (suppressClick) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      var card = event.target.closest('[data-edb-card]');
      var index = card ? cards.indexOf(card) : -1;
      if (index > -1 && index !== current) {
        /* Side by side, the card's own buttons still act once it is selected. */
        if (!wide.matches) event.preventDefault();
        request(index);
      }
    }, true);
    deck.addEventListener('keydown', function (event) {
      if (event.target !== deck) return;
      var next = null;
      if (event.key === 'ArrowRight') next = current + 1;
      else if (event.key === 'ArrowLeft') next = current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = cards.length - 1;
      if (next === null) return;
      event.preventDefault();
      request(next);
    });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        request(index);
      });
    });
    var resizeFrame = 0;
    var relayout = function () {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () {
        layout();
      });
    };
    window.addEventListener('resize', relayout, { passive: true });
    /* Carousel semantics and keyboard focus only while the cards are stacked. */
    var setMode = function () {
      if (wide.matches) {
        deck.removeAttribute('aria-roledescription');
        deck.removeAttribute('tabindex');
      } else {
        deck.setAttribute('aria-roledescription', 'carousel');
        deck.setAttribute('tabindex', '0');
      }
      cards.forEach(function (card) {
        if (wide.matches) card.removeAttribute('aria-roledescription');
        else card.setAttribute('aria-roledescription', 'slide');
      });
      sync(current);
    };
    if (wide.addEventListener) wide.addEventListener('change', setMode);

    /* The controller may have made its initial selection (?variant=) first. */
    var initial = window.KTBoltronPurchase && window.KTBoltronPurchase.getState();
    if (initial && indexOf(initial.variantId) > -1) current = indexOf(initial.variantId);
    setMode();
    /* Commit the first layout without transitions, then enable deck motion. */
    track.getBoundingClientRect();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        deck.classList.add('is-ready');
      });
    });
  }

  /* Gift dialog: grows from the tapped gift control; focus trap, scroll lock. */
  function initGifts(buy) {
    var modal = buy.querySelector('[data-edb-gifts]');
    var panel = modal && modal.querySelector('[data-edb-gifts-panel]');
    if (!panel) return;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    var backdrop = modal.querySelector('.edb-gifts__backdrop');
    var modalState = 'closed';
    var giftTrigger = null;
    var panelAnimation = null;
    var backdropAnimation = null;
    var scrollLock = null;

    var lockScroll = function () {
      var html = document.documentElement;
      var gutter = window.innerWidth - html.clientWidth;
      scrollLock = { html: html.style.overflow, body: document.body.style.overflow, padding: document.body.style.paddingRight };
      html.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (gutter > 0) document.body.style.paddingRight = gutter + 'px';
    };
    var unlockScroll = function () {
      if (!scrollLock) return;
      document.documentElement.style.overflow = scrollLock.html;
      document.body.style.overflow = scrollLock.body;
      document.body.style.paddingRight = scrollLock.padding;
      scrollLock = null;
    };
    var originTransform = function () {
      var box = panel.getBoundingClientRect();
      var source = giftTrigger && giftTrigger.isConnected ? giftTrigger.getBoundingClientRect() : null;
      if (!source || !box.width) return 'translate(0, 24px) scale(0.9)';
      var dx = source.left + source.width / 2 - (box.left + box.width / 2);
      var dy = source.top + source.height / 2 - (box.top + box.height / 2);
      var scale = Math.max(0.08, Math.min(0.3, source.width / box.width));
      return 'translate(' + dx.toFixed(1) + 'px, ' + dy.toFixed(1) + 'px) scale(' + scale.toFixed(3) + ')';
    };
    var focusables = function () {
      return toArray(panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')).filter(function (element) {
        return !element.disabled && !element.closest('[hidden]') && element.getClientRects().length;
      });
    };
    var cancelAnimations = function () {
      if (panelAnimation) panelAnimation.cancel();
      if (backdropAnimation) backdropAnimation.cancel();
      panelAnimation = null;
      backdropAnimation = null;
    };

    var openGifts = function (trigger) {
      if (modalState === 'open' || modalState === 'opening') return;
      cancelAnimations();
      giftTrigger = trigger;
      toArray(modal.querySelectorAll('[data-ktb-addon]')).forEach(function (row, index) {
        row.style.setProperty('--edb-row', index);
      });
      if (modalState === 'closed') lockScroll();
      modal.hidden = false;
      modal.classList.add('is-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      modalState = 'opening';
      (panel.querySelector('.edb-gifts__close') || panel).focus({ preventScroll: true });
      if (motion.matches || !panel.animate) {
        modalState = 'open';
        return;
      }
      if (backdrop) backdropAnimation = backdrop.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, easing: 'ease-out' });
      panelAnimation = panel.animate(
        [{ transform: originTransform(), opacity: 0 }, { opacity: 1, offset: 0.35 }, { transform: 'none', opacity: 1 }],
        { duration: 580, easing: EASE }
      );
      panelAnimation.finished.then(function () {
        if (modalState === 'opening') modalState = 'open';
      }).catch(function () {});
    };
    var finishClose = function () {
      cancelAnimations();
      modal.hidden = true;
      modal.classList.remove('is-open');
      unlockScroll();
      if (giftTrigger) {
        giftTrigger.setAttribute('aria-expanded', 'false');
        if (giftTrigger.isConnected) giftTrigger.focus({ preventScroll: true });
      }
      modalState = 'closed';
    };
    var closeGifts = function () {
      if (modalState === 'closed' || modalState === 'closing') return;
      modalState = 'closing';
      if (motion.matches || !panel.animate) {
        finishClose();
        return;
      }
      cancelAnimations();
      if (backdrop) backdropAnimation = backdrop.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 380, easing: 'ease-in', fill: 'forwards' });
      panelAnimation = panel.animate(
        [{ transform: 'none', opacity: 1 }, { opacity: 1, offset: 0.55 }, { transform: originTransform(), opacity: 0 }],
        { duration: 460, easing: EASE, fill: 'forwards' }
      );
      panelAnimation.finished.then(function () {
        if (modalState === 'closing') finishClose();
      }).catch(function () {});
    };

    buy.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-edb-gift-trigger]');
      if (trigger && !trigger.disabled) {
        openGifts(trigger);
        return;
      }
      if (event.target.closest('[data-edb-gifts-close]')) {
        event.preventDefault();
        closeGifts();
      }
    });
    document.addEventListener('keydown', function (event) {
      if (modalState !== 'open' && modalState !== 'opening') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeGifts();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) {
        event.preventDefault();
        panel.focus();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      } else if (!panel.contains(document.activeElement)) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* ── 2. Colour carousel (07) ──────────────────────────────────────── */
  var chooser = root.querySelector('[data-edb-choose]');
  if (chooser) initChooser(chooser);

  function initChooser(chooser) {
    var track = chooser.querySelector('[data-edb-ch-track]');
    var slides = track ? toArray(track.querySelectorAll('[data-edb-ch-slide]')) : [];
    if (!slides.length) return;
    var dots = toArray(chooser.querySelectorAll('[data-edb-ch-dot]'));
    var prev = chooser.querySelector('[data-edb-ch-prev]');
    var next = chooser.querySelector('[data-edb-ch-next]');
    var current = 0;
    var settleTimer = 0;

    var indexOf = function (variantId) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-variant-id') === String(variantId)) return i;
      }
      return -1;
    };
    /* The slide whose centre is closest to the track's centre. */
    var nearest = function () {
      var middle = track.scrollLeft + track.clientWidth / 2;
      var best = 0;
      var bestDistance = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    };
    var mark = function (index) {
      current = index;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.setAttribute('aria-disabled', index === 0 ? 'true' : 'false');
      if (next) next.setAttribute('aria-disabled', index === slides.length - 1 ? 'true' : 'false');
    };
    var go = function (index, instant) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[index];
      track.scrollTo({
        left: slide.offsetLeft + slide.offsetWidth / 2 - track.clientWidth / 2,
        behavior: instant || motion.matches ? 'auto' : 'smooth'
      });
      mark(index);
    };

    /* Once the track rests, its centred slide becomes the selected variant.
       Refused while the cart is busy: the controller re-emits its state. */
    var settle = function () {
      var index = nearest();
      mark(index);
      var id = slides[index].getAttribute('data-variant-id');
      var api = window.KTBoltronPurchase;
      var state = api && api.getState();
      if (!api || (state && String(state.variantId) === id)) return;
      document.dispatchEvent(new CustomEvent('ktb:request-variant', { detail: { variantId: Number(id), source: 'chooser' } }));
    };
    track.addEventListener('scroll', function () {
      mark(nearest());
      window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(settle, 140);
    }, { passive: true });

    document.addEventListener('ktb:variant-change', function (event) {
      var index = event.detail ? indexOf(event.detail.variantId) : -1;
      if (index > -1 && index !== nearest()) go(index, event.detail.source !== 'chooser');
    });

    if (prev) prev.addEventListener('click', function () { if (current > 0) go(current - 1); });
    if (next) next.addEventListener('click', function () { if (current < slides.length - 1) go(current + 1); });
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () { go(index); });
    });
    track.addEventListener('click', function (event) {
      var slide = event.target.closest('[data-edb-ch-slide]');
      var index = slides.indexOf(slide);
      if (index > -1 && index !== current) go(index);
    });
    track.addEventListener('keydown', function (event) {
      var target = null;
      if (event.key === 'ArrowRight') target = current + 1;
      else if (event.key === 'ArrowLeft') target = current - 1;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = slides.length - 1;
      if (target === null) return;
      event.preventDefault();
      go(target);
    });

    var resizeFrame = 0;
    window.addEventListener('resize', function () {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function () { go(current, true); });
    });

    /* The controller may have made its initial selection (?variant=) first. */
    var state = window.KTBoltronPurchase && window.KTBoltronPurchase.getState();
    var start = state ? indexOf(state.variantId) : -1;
    if (start < 0) {
      slides.forEach(function (slide, i) { if (slide.classList.contains('is-active')) start = i; });
    }
    go(Math.max(start, 0), true);
  }

  /* ── 1. Scroll reveal ─────────────────────────────────────────────── */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    root.classList.add('edb-reveal-all', 'edb-ready');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  root.querySelectorAll('[data-edb-reveal]').forEach(function (el) {
    io.observe(el);
  });
  root.classList.add('edb-ready');
})();
